<div class="row">
    <div class="col-sm-12 col-lg-6">
        <div class="card">
            <div class="card-header bg-dark">
                <div class="row">
                    <div class="col-12 text-center">
                        <img width="50%" src="assets/metal-logo.png" alt="Metal Supermarkets Logo" class="mt-5" />
                        <h1 class="my-3 text-white">Franchisee Portal</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center text-white p-5">
                        Version: {{version}}
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-12 text-center">
                        <button typ="button" class="btn btn-lg btn-primary" (click)="login()">Login</button>
                    </div>
                </div>
            </div>
            <div class="card-header bg-white mt-3">
                <div class="row" *ngIf="message">
                    <div class="col-12 text-center">
                        {{message}}
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 text-center">
                        <button typ="button" class="btn btn-sm btn-outline-primary" (click)="logout()">Logout</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>